export const BATTLE_SCARS = {
    "1": {
        name: 'CRIPPLING DAMAGE',
        flavor: 'Reduced to walking wounded, plagued by engine   Jou/ts or hobbled by lacerations, the impaired still  limp stoically into battle.',
        description: "This unit cannot Advance and you must subtract 1'' from the Move characteristic of models in this unit."
    },
    "2": {
        name: 'BATTLE-WEARY',
        flavor: "Sopped of energy ond impetus, fighting formations  that endure extended tours can be psychologically crippled by constant attack.",
        description: "Each time this unit takes a Battle-shock, Leadership,         Desperate Escape or Out of Action test, subtract 1                from that test."
    },
    "3": {
        name: 'FATIGUED',
        flavor: "These fighters have suffered heavily in war, indecision                and disorganisation hampering their ability at                effective battlefield cohesion.",
        description: "Subtract 1 from the Objective Control characteristic                of models in this unit and this unit never receives a                Charge bonus."
    },
    "4": {
        name: 'DISGRACED',
        flavor: "Having committed some gross failure in battle, these                warriors are excluded from high strategies and tasked                with unheroic actions.",
        description: "You cannot use any Stratagems to affect this unit and                this unit cannot be Marked for Greatness."
    },
    "5": {
        name: 'MARK OF SHAME',
        flavor: "Humiliated, cursed or haunted by terrible injury,                these fighters are shunned or avoided and few will                acknowledge them even in war.",
        description: "This unit cannot form an Attached unit, it is                unaffected by the Aura abilities of friendly units, and                it cannot be Marked for Greatness."
    },
    "6": {
        name: 'DEEP SCARS',
        flavor: "Battle damage and grievous injuries can linger                and fester, worsening until they severely hamper a                unit's constitution.",
        description: "Each time a Critical Hit is scored against this unit, that                attack automatically wounds this unit."
    },

}